import { useAuth } from '@/context/auth-context';
import useAppwriteTableQuery from '@/hooks/use-appwrite-table';
import { APP_COLLECTIONS, AppBankAccount } from '@polybank/shared';
import { useMemo } from 'react';

export function useBankAccounts() {
  const { user, isAuthenticated } = useAuth();
  const { updateItem, ...query } = useAppwriteTableQuery(
    APP_COLLECTIONS.BANK_ACCOUNTS,
    [],
    {
      enabled: isAuthenticated && !!user,
    }
  );

  const bankAccountsMap = useMemo(() => {
    return query.data.rows.reduce(
      (acc, row) => {
        acc[row.$id!] = row;
        return acc;
      },
      {} as Record<string, AppBankAccount>
    );
  }, [query.data.rows]);

  return {
    ...query,
    data: { ...query.data, rows: query.data.rows ?? [] },
    updateItem,
    bankAccountsMap,
  };
}
